import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Image } from 'semantic-ui-react';

import Confirm from '../../../../components/Confirm';
import styles from './TrainingEventHeader.module.scss';
import { TrainingEventHeaderProps } from './TrainingEventHeaderProps';
import { DEFAULT_LOGO_URL } from '../../../../constants/customizations';
import DeleteEventModal from '../DeleteEventModal';

const TrainingEventHeader: FC<TrainingEventHeaderProps> = ({
  onClose, onSubmit, isFormValid, clubLogoUrl, header,
  event, cancelEvent, isSubmitted,
}) => {
  const [translate] = useTranslation();
  const [deletionModalOpened, setDeletionModalOpened] = useState(false);

  const handleCancel = (id: number) => () => {
    cancelEvent(id);
    onClose();
  };

  const closeDeleteModal = () => {
    setDeletionModalOpened(false);
  };

  const openDeleteModal = () => {
    setDeletionModalOpened(true);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftWrapper}>
        <Image
          src={clubLogoUrl || DEFAULT_LOGO_URL}
          className={styles.image}
        />
        <h2 className={styles.header}>
          {header}
        </h2>
      </div>
      <div className={styles.rightWrapper}>
        {event && event.id ? [
          <Button key="delete" basic primary onClick={openDeleteModal} content={translate('DELETE')} />,
          <Confirm
            basic
            headerText={translate('CONFIRM_CANCEL_TRAINING')}
            confirmText={translate('CONFIRM_CANCEL_TRAINING_TEXT')}
            onConfirm={handleCancel(event.id)}
            primary
            triggerText={translate('CANCEL_EVENT')}
            key="cancel"
          />,
        ] : (
          <Button basic primary onClick={onClose} content={translate('CANCEL')} />
        )}

        <Button primary disabled={!event && isSubmitted && !isFormValid} onClick={onSubmit}>
          {translate(event ? 'SAVE_EVENT' : 'CREATE_EVENT')}
        </Button>
      </div>
      {event && deletionModalOpened && <DeleteEventModal onClose={closeDeleteModal} />}
    </div>
  );
};

export default TrainingEventHeader;
